import {Box} from '@mui/material';
import React from 'react';

interface WrapperProps {
  heading: React.ReactNode;
  component: React.ReactNode;
}
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const Wrapper = ({heading, component}: WrapperProps) => {
  return (
    <Box
      sx={{
        backgroundColor: ' #FFFFFF',
        borderRadius: isAppIimjobs ? 4 : {xxs: 0, md: 2},
        padding: 1,
        marginBottom: isAppIimjobs ? 1.25 : 2,
      }}
    >
      <Box
        sx={{
          backgroundColor: ' #F9FAFB',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: isAppIimjobs ? 4 : 2,
        }}
      >
        {heading}
        {component}
      </Box>
    </Box>
  );
};

export default Wrapper;
